export const ServiceRequestDefaultSettings = {
    OffSet: '0',
    SearchField: 'status',
    Open: 'Open',
    DefaultPageSize: '100',
    SupportTopicIdFieldName: 'SupportTopicId',
    Equals: 'Equals',
    DataType: 'String'
}